<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>胸卡列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-table
      :data="pmData"
      style="width: 50%">
      <el-table-column
        prop="area"
        label="面积（平方米）">
      </el-table-column>
      <el-table-column
        prop="number"
        label="胸卡数量（张）">
      </el-table-column>

 
    </el-table>
    <div class="textBox">
      <p>● 如特殊情况需要增加胸卡数量，请联系主办方</p>
      <p>● 只有展商才有权申请胸卡，与参展公司无关的人员，组织单位有权不予发放。严禁非展台工作人员佩带胸卡。</p>
      <p>● 标准展位展商可于 2024 年 8 月 27 日 13:00 至 17: 00， 在展商报到处领取胸卡。</p>
      <p>● 特装展位展商可于 2024 年 8 月 26-27 日 09:00 至 17: 00， 在展商报到处领取胸卡。</p>
    </div>
   

    <div class="operas">
      <div class="tktNum">
        <span>可申请证件数量：<b style="color:red;">{{ticketNumObj.totalTicketNum}}</b>张，</span>
        <span>已提交证件数量：<b style="color:green;">{{ticketNumObj.submittedTicketNum}}</b>张</span>
      </div>
      <!-- <el-button type="primary" @click="addCard" :style="buttonStyle">新增</el-button> -->
    </div>
    <div style="color:red;font-size:16px;font-weight:bold;margin-top:-0px">展商胸卡申请已关闭，请联系主办方</div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="tktName"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="tktComName"
        label="公司名">
      </el-table-column>
      <!-- <el-table-column
        label="头像"
        width="160">
        <template slot-scope="scope">
          <img style="max-height:100px;" :src="scope.row.photo"/>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="tktPassportNo"
        label="证件号">
      </el-table-column>
      <el-table-column
        prop="tktRank"
        label="职位">
      </el-table-column>
      <!-- <el-table-column
        label="操作"
        width="160">
        <template slot-scope="scope" >
          <div  v-show="scope.row.tktIfMakeCard !='1'">
            <el-button @click="editCard(scope.row)" type="text" size="small">修改</el-button>
            <el-button @click="deletCard(scope.row)" type="text" size="small">删除</el-button>
          </div>

        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import tools from '../../utils/tools.js';
export default {
  name: 'card',
  data() {
    return {
      tableData: [],
      ticketNumObj: {},
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      pmData:[
        {
          area:"20以下",
          number:'6'
        },
        {
          area:"21-50",
          number:'12'
        },
        {
          area:"51-100",
          number:'20'
        },
        {
          area:"101-250",
          number:'30'
        },
        {
          area:">250以上",
          number:'40'
        }
      ]
    }
  },
  mounted() {
    this.getTicket()
    this.getticketnum()
  },
  methods: {
    getticketnum() {
      api.getticketnum().then(res => {
        if (res.data.code === 200) {
          this.ticketNumObj = res.data.data
          this.overlayshow = false
        }
      })
    },
    addCard() {
      if (this.ticketNumObj.totalTicketNum > this.ticketNumObj.submittedTicketNum) {
        this.$router.push({path: '/addCard', query: {type: 'add'}})
      } else {
        this.$notify({
          title: '错误',
          message: '证件数量已达上限',
          type: 'error'
        });
      }
    },
    deletCard(row) {
      this.$confirm('确定删除该证件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        api.deleteticket({tktID: ''+row.tktID}).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.getTicket()
            this.getticketnum()
          }
        })
      }).catch(() => {});
    },
    resetForm() {
      this.ruleForm={
        tktName: '',
        tktComName: '',
        photo: '',
        tktIDCard: '',
        tktRank: ''
      }
    },
    getTicket() {
      api.ticketlist().then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data
        }
      })
    },
    editCard(row, type) {
      this.$router.push({path: '/addCard', query: {type: 'edit', tktID: row.tktID}})
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .tktNum{
    span{
      font-size: 14px;
      b{
        font-size: 16px;
        padding: 0 10px;
      }
    }
  }
  .operas{
    text-align: right;
    padding: 20px 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .fileParent {
    position: relative;
    img {
      position: absolute;
      width: 60px;
      height: 39px;
      left: 0;
      top: 0;
    }
  }
  .file {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  .textBox{
    font-size: 12px;
    padding-top:10px;
    line-height: 26px;
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:120px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
